import { useRef } from 'react';
import type { FC } from 'react';

import cn from 'classnames';
import { Cancel, CloseFill, Search as SearchIcon } from '@vgno/icons';
import { useTranslation } from 'react-i18next';

import { useSearchBox } from './useSearchBox';

import * as styles from './SearchBox.module.scss';

interface SearchBoxProps {
  variant?: 'desktop' | 'mobile';
}

export const SearchBox: FC<SearchBoxProps> = ({ variant = 'desktop' }) => {
  const { t } = useTranslation();
  const { query, refine, reset } = useSearchBox();
  const inputRef = useRef<HTMLInputElement>(null!);

  const CancelIcon = variant === 'desktop' ? Cancel : CloseFill;

  return (
    <div
      className={cn(styles.container, {
        [styles.isMobile]: variant === 'mobile',
      })}
    >
      <SearchIcon className={styles.searchIcon} />
      <input
        ref={inputRef}
        className={styles.input}
        type="search"
        placeholder={t('Type here to apply')}
        spellCheck={false}
        maxLength={512}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        value={query}
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus
        onChange={(event) => {
          refine(event.currentTarget.value);
        }}
      />
      {query ? (
        <button
          className={styles.cancelButton}
          onClick={() => {
            reset();

            inputRef.current.focus();
          }}
        >
          <CancelIcon />
        </button>
      ) : null}
    </div>
  );
};
